import { render, staticRenderFns } from "./CopyrightFooter.vue?vue&type=template&id=2e629290&scoped=true&"
import script from "./CopyrightFooter.vue?vue&type=script&lang=js&"
export * from "./CopyrightFooter.vue?vue&type=script&lang=js&"
import style0 from "./CopyrightFooter.vue?vue&type=style&index=0&id=2e629290&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e629290",
  null
  
)

export default component.exports